import { render, staticRenderFns } from "./LostPassword.vue?vue&type=template&id=3aa64f9c&scoped=true&lang=pug&"
import script from "./LostPassword.vue?vue&type=script&lang=js&"
export * from "./LostPassword.vue?vue&type=script&lang=js&"
import style0 from "./LostPassword.vue?vue&type=style&index=0&id=3aa64f9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa64f9c",
  null
  
)

export default component.exports